import { render, staticRenderFns } from "./quote-units-table.vue?vue&type=template&id=289d6100&scoped=true"
import script from "./quote-units-table.vue?vue&type=script&setup=true&lang=js"
export * from "./quote-units-table.vue?vue&type=script&setup=true&lang=js"
import style0 from "./quote-units-table.vue?vue&type=style&index=0&id=289d6100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289d6100",
  null
  
)

export default component.exports